import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-drag',
  templateUrl: './drag-wrapper.component.html',
  styleUrls: ['./drag-wrapper.component.scss']
})
export class DragWrapperComponent {

  @Input() contentClass: string = '';

  clickTimeout: any;
  isEditing = false;
  isDragging = false;

  onClick() {
    // Delay click to distinguish from double-click
    clearTimeout(this.clickTimeout);
    this.clickTimeout = setTimeout(() => {
      if (!this.isEditing) {
        this.isDragging = false; // Just in case
      }
    }, 200); // delay must be less than double-click speed
  }

  onDoubleClick(event: MouseEvent) {
    clearTimeout(this.clickTimeout);
    this.isEditing = true;
    this.isDragging = false;
    // Optionally focus the div if needed
    const target = event.target as HTMLElement;
    setTimeout(() => target.focus());
  }

  onBlur() {
    this.isEditing = false;
  }

  onDragStarted() {
  }

  onDragEnded(event: any) {
  }

}
